import React from 'react'
import { FontIcon } from 'react-md'
import { Link } from '..'
import { inject, observer } from 'mobx-react'
import './CompanyCard.scss'

const CompanyCard = ({
  className = '',
  href      = '',
  thumbnail = false,
  value     = {},
  ...props
}) => {
  return (      
    <Link 
      to={href}
      className={thumbnail ? 'mpk-full full-width' : ''}
      onClick={ e => {
        e.preventDefault()
        e.stopPropagation()
        props.navigationStore.redirectTo(href)
      }}
    >
      <div className={`mpk-company-card mpk-border solid dark ${className} ${thumbnail ? 'thumbnail mpk-flex align-center border-bottom' : 'border-all thin '}`}>
        <div className="image mpk-flex justify-center align-center">
          { value.icon ? (
            <img src={value.icon} alt={value.name}/>
          ) : (
            <FontIcon iconClassName="mdi mdi-atom"/>
          )}
        </div>
        <div className={`mpk-padding-N padding-all ${thumbnail ? '' : 'mpk-border thin solid dark border-top'}`}>
          <div className="mpk-font weight-B">{value.name}</div>
          <div className="mpk-font size-NS">{value.industry}</div>
        </div>
      </div>
    </Link>
  )
}

export default inject('navigationStore')(observer(CompanyCard))
